// extracted by mini-css-extract-plugin
export var chevronIcon = "_am-2";
export var teamName = "_am-1";
export var teamSwitcherButton = "_am-0";